import { startCase as lo_startCase } from 'es-toolkit';

// Canonical display order for store-locator sport groups (`sportGroups` on a
// retail location). Anything not listed here is sorted alphabetically after.
const SPORT_GROUP_ORDER = ['lacrosse', 'baseball_softball', 'hockey'];

// Display-label overrides for cases where start-casing the raw value isn't
// enough (e.g. joining two sports with an ampersand).
const SPORT_GROUP_LABELS: Record<string, string> = {
    baseball_softball: 'Baseball & Softball'
};

export function useSportGroups() {
    function sportGroupLabel(group: string): string {
        return SPORT_GROUP_LABELS[group] ?? lo_startCase(group.replace(/_/g, ' '));
    }

    function sortSportGroups(groups: string[]): string[] {
        return [...groups].sort((a, b) => {
            const ia = SPORT_GROUP_ORDER.indexOf(a);
            const ib = SPORT_GROUP_ORDER.indexOf(b);
            if (ia === -1 && ib === -1) return a.localeCompare(b);
            if (ia === -1) return 1;
            if (ib === -1) return -1;
            return ia - ib;
        });
    }

    return {
        sportGroupLabel,
        sortSportGroups
    };
}
